import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  toSubscriptionModal,
  toAuthModal,
  syntheticLocationChange,
} from '@chegg-wt/core/state/instrumentation/actions'
import { SADefaultFlow } from '../constants/site'
import { UserRoles } from '../constants/user'
import { AppRoute } from '../types/core'
import { navigated } from '../state/app/actions'
import { initializedSelector } from '../state/app/selectors'
import { isRioInitSelector } from '../state/instrumentation/selectors'
import { userRoleSelector } from '../state/user/selectors'
import usePriceTest from './usePriceTest'

interface UseUpgradeUserRedirectArgs {
  siteCode: string
  alreadyUpgradedRoute: AppRoute
  defaultAuthFlow?: SADefaultFlow.LOGIN | SADefaultFlow.SIGN_UP
  shouldShowSignupValueProps?: boolean
}

const useUpgradeUserRedirect = ({
  alreadyUpgradedRoute,
  defaultAuthFlow = SADefaultFlow.SIGN_UP,
}: UseUpgradeUserRedirectArgs) => {
  const userRole = useSelector(userRoleSelector)
  const isRioInit = useSelector(isRioInitSelector)
  const initialized = useSelector(initializedSelector)

  const dispatch = useDispatch()

  const [hasJustUpgraded, setHasJustUpgraded] = useState(false)
  const [shouldShowUpgradeModal, setShouldShowUpgradeModal] = useState(
    initialized && userRole === UserRoles.FREE_USER
  )

  const { pricingExperimentReady } = usePriceTest()
  useEffect(() => {
    if (initialized && pricingExperimentReady) {
      if (userRole === UserRoles.PRO_USER && !hasJustUpgraded) {
        dispatch(navigated(alreadyUpgradedRoute))
      }
      setShouldShowUpgradeModal(userRole === UserRoles.FREE_USER || hasJustUpgraded)
    }
  }, [userRole, hasJustUpgraded, defaultAuthFlow, initialized, pricingExperimentReady])

  useEffect(() => {
    if (isRioInit && userRole === UserRoles.NOT_LOGGED_IN) {
      dispatch(syntheticLocationChange({ routeName: toAuthModal }))
    }

    if (isRioInit && userRole === UserRoles.FREE_USER) {
      dispatch(syntheticLocationChange({ routeName: toSubscriptionModal }))
    }
  }, [isRioInit, userRole])

  return {
    setHasJustUpgraded,
    shouldShowUpgradeModal,
  }
}

export default useUpgradeUserRedirect
